(function() {

  const SP_SIZE = 768;

  function setAnswer(){
    const isSP = $(window).width() < SP_SIZE;
    const $answer = $('.js-answer');
    if(isSP){
      $answer.removeClass('is-show');
      $answer.parents(".coach-box").next(".coach-box").slideUp();
    } else {
      $answer.addClass('is-show');
      $answer.parents(".coach-box").next(".coach-box").slideDown();
    }
  }


  function answerShow() {
    $('.js-answer').on('click', function () {
      const $this = $(this);
      const isItemShow = $this.hasClass('is-show');
      if (isItemShow) {
        $this.removeClass('is-show');
        $this.parents(".coach-box").next(".coach-box").slideUp();
      } else {
        $this.addClass('is-show');
        $this.parents(".coach-box").next(".coach-box").slideDown();
      }
      return false;
    });
  }

  const isPageReport = $('.report').length;
  if(isPageReport) {
    setAnswer();
    answerShow();
  }
})();